var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('sa-page-layout',{staticClass:"sa-no-space",attrs:{"titolo":"AnDIamo - Utente","btnRouterBackVisible":""}},[_c('template',{slot:"table-body"},[_c('AndiamoUtenteFormComponent',{ref:"cmpAndiamoUtenteFormComponent"})],1)],2)}
var staticRenderFns = []

export { render, staticRenderFns }